import Link from "next/link";
import FAIcon from "@/components/icons/faIcon";
import { services } from "@/lib/services";
import MenuFeatureBarLink from "@/components/menu/menuFeatureBarLink";

const PANEL_WIDTH = 1000;
const PANEL_SURFACE = "bg-neutral-50";
const PANEL_GLOW = "shadow-[0_34px_110px_rgba(6,4,12,0.18)]";
const DROPDOWN_SHADOW = "shadow-3xl shadow-blackq/20";

const FEATURED = {
  eyebrow: "Our services",
  title:
    "Expert consultancy, inspections and training shaped around real operational risk.",
  description:
    "Explore the full SML service offering, from advisory support and occupational hygiene through to statutory inspection management and consultant-led training.",
  href: "/services",
  cta: "View all services",
  image: "/images/services/sml-expert-advice.png",
  imagePosition: "44% center",
  metrics: ["Consultancy", "Inspections", "Training"],
};

function MenuArrowIcon({ className = "", noMargin = false, size }) {
  return (
    <FAIcon
      icon="arrow-right"
      className={className}
      noMargin={noMargin}
      size={size}
    />
  );
}

const LIGHT_CARD_SURFACE = "bg-white";

function DesktopDropdown({ id, onNavigate }) {
  return (
    <div
      id={id}
      style={{ width: `${PANEL_WIDTH}px`, maxWidth: "calc(100vw - 2.5rem)" }}
      className={`relative overflow-hidden rounded-lg p-8 ${PANEL_GLOW} ${DROPDOWN_SHADOW} ${PANEL_SURFACE}`}
    >
      <div className="space-y-6">
        <div className="flex flex-col gap-2">
          {services.map((item) => (
            <Link
              key={item.title}
              href={item.href}
              onClick={onNavigate}
              className={`group grid gap-4 rounded-lg px-6 py-6 transition-all duration-300 hover:-translate-y-0.5 md:grid-cols-3 md:items-center ${LIGHT_CARD_SURFACE}`}
            >
              <div className="col-span-1 flex items-center gap-4">
                <h4 className="text-2xl font-medium leading-none tracking-[-0.05em] text-[#06040c]">
                  {item.title}
                </h4>
              </div>

              <div className="col-span-2 flex gap-4">
                <p className="max-w-xl text-sm leading-6 text-[#06040c]/64 md:pl-4">
                  {item.description}
                </p>
                <MenuArrowIcon className="h-5 w-5 shrink-0 self-center text-[#06040c]/38 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-[#06040c]" />
              </div>
            </Link>
          ))}

          <MenuFeatureBarLink
            href={FEATURED.href}
            onNavigate={onNavigate}
            description={FEATURED.description}
            cta={FEATURED.cta}
            ctaTextClassName="max-w-32 font-semibold !text-[1.4rem]"
            buttonClassName="h-13 w-13"
          />
        </div>
      </div>
    </div>
  );
}

function MobileContent({ onNavigate }) {
  return (
    <div className="space-y-1.5 pb-2.5">
      {services.map((item) => (
        <Link
          key={item.title}
          href={item.href}
          onClick={onNavigate}
          className="flex min-w-0 items-start justify-between gap-3 rounded-md bg-white px-3.5 py-2.5"
        >
          <div className="min-w-0">
            <p className="text-md font-semibold text-[#06040c]">{item.title}</p>
            <p className="mt-1 text-[0.84rem] leading-4.5 text-[#06040c]/64">
              {item.description}
            </p>
          </div>
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-[#06040c]">
            <MenuArrowIcon className="mx-auto" noMargin size={14} />
          </span>
        </Link>
      ))}

      <Link
        href={FEATURED.href}
        onClick={onNavigate}
        className="flex min-w-0 items-start justify-between gap-3 rounded-md bg-white px-3.5 py-2.5 text-[#06040c] transition-all duration-300 hover:-translate-y-0.5"
      >
        <div className="min-w-0">
          <p className="text-md font-semibold text-[#06040c]">{FEATURED.cta}</p>
          <p className="mt-1 text-[0.84rem] leading-4.5 text-[#06040c]/64">
            {FEATURED.description}
          </p>
        </div>
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-[#06040c]">
          <MenuArrowIcon className="mx-auto" noMargin size={14} />
        </span>
      </Link>
    </div>
  );
}

const servicesMenu = {
  label: "Services",
  DesktopDropdown,
  MobileContent,
};

export default servicesMenu;
